export class EstoqueProducaoAvulsaFactory {
  constructor(instance) {
    this.instance = instance;
  }

  addEntrada(data) {
    return this.instance.post('/v1/cad-estoque-producao-avulsa/entradas', data);
  }

  editEntrada(id, data) {
    return this.instance.put(
      `/v1/cad-estoque-producao-avulsa/entradas/${id}`,
      data,
    );
  }

  deleteEntrada(id, data) {
    return this.instance.delete(
      `/v1/cad-estoque-producao-avulsa/entradas/${id}`,
      { data },
    );
  }
}
